/**
 * 이 주석은 다른 파일에 주석을 달기 위한 가이드 역할을 합니다.
 * JSDoc으로 작성한 주석은 향후 HTML로 추출될 수 있기 때문에 최초작성자/최초작성일 등은 기술하지 않습니다.
 * 이러한 정보는 git의 History(log) 기능을 이용하여 조회할 수 있습니다.
 *
 * .vue 파일과 .js 파일은 반드시 분리하며 주석은 .js에만 기술하면 됩니다.
 *
 * Method 상단에는 @param과 @returns만 기술합니다.
 * Member는 옆에 단일라인 주석(//)을 사용하여 기술합니다.
 *
 * 아래는 실제 BeButton에 대한 설명입니다.
 * ====================================
 * BeButton Component
 * Buefy의  Button을 상속하여 구현함
 */
export default {
  name: 'BeButton',
  // mixin: [Button], //Mixin을 하지 않아도 잘 됨
  inheritAttrs: false, // 부모 Component에서 지정한 Element 속성을 무시 - vue 파일의 다음 구분 참조(v-bind="$attrs", v-on="$listeners")
  props: {
    /**
     * 버튼 권한
     * 예: 사용자의 페이지에 대한 권한이 Readonly인데 버튼은 Update 권한이 있어야만 한다면 화면에 표시되지 않습니다.
     */
    buttonAuthority: {
      type: String,
      default: 'R' // R(readonly), C(create), U(update), D(delete), S(save - create, update, delete), 'CRUD'처럼 조합 가능
    }

  },
  computed: {
    /**
     * 화면 표시 여부
     * 사용자의 페이지에 대한 권한 여부에 따라 보이기/숨기기 를 판단합니다.
     *
     * @returns {boolean} 화면 표시 여부
     */
    isVisible: function () {
      let visible = false
      let buttonAuthority = this.buttonAuthority
      let grantedAuthority = this.grantedAuthority

      if (buttonAuthority.includes('C')) {
        visible = !!((grantedAuthority.includes('C') || grantedAuthority.includes('S')))
      } else if (buttonAuthority.includes('U')) {
        visible = !!((grantedAuthority.includes('U') || grantedAuthority.includes('S')))
      } else if (buttonAuthority.includes('D')) {
        visible = !!((grantedAuthority.includes('D') || grantedAuthority.includes('S')))
      } else if (buttonAuthority.includes('S')) {
        visible = !!(grantedAuthority.includes('S'))
      } else { // readonly
        visible = true
      }

      return visible
    }
  },
  methods: {

  },
  data () {
    return {
      grantedAuthority: 'R' // 사용자에 대하여 화면에 부여된 권한 - 나중에는 Store 또는 메뉴에서 구해야 함
    }
  }

}
